import { Checkbox } from 'antd'

import cn from './SupplierArticlesClearPicker.module.scss'

interface SupplierArticlesClearPickerProps {
  options: string[]
  value: string[]
  onChange: (value: string[]) => void
}

function SupplierArticlesClearPicker({
  options,
  value,
  onChange,
}: SupplierArticlesClearPickerProps) {
  if (options.length === 0)
    return <span className={cn.empty}>Артикулов поставщика нет</span>

  const selectedCount = options.filter((article) =>
    value.includes(article)
  ).length
  const isAllSelected = selectedCount === options.length

  const toggle = (article: string, checked: boolean) =>
    onChange(
      options.filter((item) =>
        item === article ? checked : value.includes(item)
      )
    )

  return (
    <div className={cn.box}>
      <Checkbox
        className={cn.allRow}
        checked={isAllSelected}
        indeterminate={selectedCount > 0 && !isAllSelected}
        onChange={(event) => onChange(event.target.checked ? options : [])}
      >
        Все артикулы
      </Checkbox>
      <div className={cn.list}>
        {options.map((article) => (
          <Checkbox
            key={article}
            className={cn.row}
            checked={value.includes(article)}
            onChange={(event) => toggle(article, event.target.checked)}
          >
            {article}
          </Checkbox>
        ))}
      </div>
    </div>
  )
}

export default SupplierArticlesClearPicker
